import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../../../../singleton/axios';

export interface SeedWatchlistResult {
  seeded: boolean;
  watchlistId?: string;
  tickers?: string[];
}

interface SeedWatchlistResponse {
  data: SeedWatchlistResult;
}

async function seedWatchlist(markets: string[]): Promise<SeedWatchlistResult> {
  const { data } = await api.post<SeedWatchlistResponse>('/stock-watchlists/seed', { markets });
  return data.data;
}

/**
 * Seeds a brand-new user's default watchlist from their onboarding market
 * answers. The server owns the ticker lists and no-ops (seeded: false) for
 * any user who already has a watchlist, so the call is idempotent.
 */
export function useSeedWatchlist() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: seedWatchlist,
    onSuccess: (result) => {
      if (!result.seeded) return;
      queryClient.invalidateQueries({ queryKey: ['watchlists'] });
      queryClient.invalidateQueries({ queryKey: ['dashboard-watchlist'] });
      queryClient.invalidateQueries({ queryKey: ['watchlist-earnings'] });
      queryClient.invalidateQueries({ queryKey: ['chartsWatchlist'] });
    },
  });
}
